import React from 'react';

const MAX_DEPTH = 3;

const renderValue = (value, depth = 0) => {
    if (depth > MAX_DEPTH) {
        return <span className='copilot-chat-json-truncated'>...</span>;
    }

    if (Array.isArray(value)) {
        return (
            <ul className='copilot-chat-json-list'>
                {value.map((item, index) => <li key={`array-item-${index}`}>{renderValue(item, depth + 1)}</li>)}
            </ul>
        );
    }

    if (value && typeof value === 'object') {
        return (
            <div className='copilot-chat-json-object'>
                {Object.entries(value).map(([key, nestedValue]) => {
                    return (
                        <div className='copilot-chat-json-row' key={key}>
                            <span className='copilot-chat-json-key'>{key}:</span>
                            <span className='copilot-chat-json-value'>{renderValue(nestedValue, depth + 1)}</span>
                        </div>
                    );
                })}
            </div>
        );
    }

    return <span>{String(value ?? '')}</span>;
};

const JsonStructure = ({ structuredData }) => {
    return (
        <div className='copilot-chat-message copilot-chat-message--structured assistant'>
            <div className='copilot-chat-json-tree'>
                {renderValue(structuredData)}
            </div>
        </div>
    );
};

export default JsonStructure;
